// Groups the flat `tech` arrays in experience.js into labelled rows.
// Anything not listed here lands in the last group, so a new tech tag never disappears.
export const techGroups = [
  {
    key: 'code',
    label: 'code',
    items: [
      'C#',
      '.NET Core',
      '.NET Framework',
      'Angular',
      'React JS',
      'Express JS',
      'ASP.NET MVC',
      'Entity Framework',
      'WCF',
      'SyncFusion',
      'AutoMapper',
      'MediatR',
      'Matlab',
      'NetLogo',
    ],
  },
  {
    key: 'data',
    label: 'data',
    items: [
      'PostgreSQL',
      'MongoDB Atlas',
      'SQL',
      'ElasticSearch',
      'Kafka',
      'RabbitMQ',
      'ETL',
      'SQL Agent Jobs',
      'Stored Procedures',
      'SSRS',
      'Big Data',
      'Databases',
    ],
  },
  {
    key: 'infra',
    label: 'infra',
    items: [
      'Microservices',
      'API Gateway',
      'Kubernetes',
      'Azure APIM',
      'Azure App Service',
      'AWS Elastic Beanstalk',
      'S3',
      'CloudFront',
      'Azure DevOps',
    ],
  },
  { key: 'tools', label: 'tools', items: [] },
];
